var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './index.scss';
import React from 'react';
import ResponsiveItem from '~/components/responsive_item';
import { useContentLibrary } from '../../../providers/content_library_provider';
import CopyTextButton from './copy_text_button/index';
import ParentDocuments from './parent_documents/index';
const ClauseSearchResult = (_a) => {
    var { clause } = _a, rest = __rest(_a, ["clause"]);
    const { activeClause, selectClause } = useContentLibrary();
    const isActiveClause = activeClause && clause.id === activeClause.id;
    const getTextHighlights = () => {
        var _a;
        const highlights = (_a = clause.highlight) === null || _a === void 0 ? void 0 : _a.clauseText;
        let text = clause.source.clauseText;
        if (highlights && highlights.length > 0) {
            highlights.forEach((textHighlight) => {
                const strippedTextHighlight = textHighlight.replace(/(<([^>]+)>)/gi, '');
                text = text.replace(strippedTextHighlight, textHighlight);
            });
        }
        return text;
    };
    return (React.createElement("div", Object.assign({}, rest, { onClick: () => selectClause(clause), className: `result${isActiveClause ? ' selected' : ''}` }),
        React.createElement("div", { className: 'result-header' },
            React.createElement("div", { className: 'result-title' },
                React.createElement(ResponsiveItem, { overflowText: clause.source.primaryCategoryTag },
                    React.createElement("h6", null,
                        React.createElement("div", { className: 'result-category overflow-ellipsis' }, clause.source.primaryCategoryTag))),
                React.createElement(ResponsiveItem, { overflowText: clause.source.primaryDescriptorTag, fontSize: '14px' },
                    React.createElement("div", { className: 'result-descriptor overflow-ellipsis' }, clause.source.primaryDescriptorTag))),
            React.createElement("div", { className: 'result-info' },
                React.createElement(ParentDocuments, { clause: clause }),
                React.createElement(CopyTextButton, { clause: clause }))),
        React.createElement("div", { className: 'overflow-scroll-gradient result-body' },
            React.createElement("div", { className: 'result-content-wrapper' },
                React.createElement("div", { className: 'result-content', dangerouslySetInnerHTML: {
                        __html: getTextHighlights(),
                    }, "data-testid": isActiveClause ? 'active-clause-text' : '' })))));
};
export default ClauseSearchResult;
